/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Languages } from './Languages'
import { useAuth } from '../../../../app/modules/auth/core/AuthProvider'
import { useIntl } from 'react-intl'
import type { User } from '../../../../app/modules/auth/core/_models'
import { UserAvatar } from './UserAvatar'

function getAssignedRoleLabel(user: User | null | undefined): string {
  if (!user) {
    return 'User'
  }
  if (user.roleFlags?.isAdmin) {
    return 'Admin'
  }
  if (user.roleFlags?.isManager) {
    return 'Manager'
  }
  if (user.roleFlags?.isSiteManager) {
    return 'Site Manager'
  }
  return 'User'
}

function getRoleBadgeClass(roleLabel: string): string {
  switch (roleLabel) {
    case 'Admin':
      return 'badge-light-danger'
    case 'Manager':
      return 'badge-light-primary'
    case 'Site Manager':
      return 'badge-light-info'
    default:
      return 'badge-light'
  }
}

const HeaderUserMenu: FC = () => {
  const { user, logout } = useAuth()
  const intl = useIntl()
  const roleLabel = getAssignedRoleLabel(user)

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <UserAvatar user={user} size='lg' className='me-4 flex-shrink-0' />
          <div className='d-flex flex-column min-w-0'>
            <div className='fw-bolder text-gray-800 fs-5 text-truncate'>
              {user?.name} {user?.surname}
            </div>
            <div className='fw-semibold text-muted fs-7 text-truncate'>{user?.email}</div>
            <div className='mt-2'>
              <span className={`badge ${getRoleBadgeClass(roleLabel)} fw-bold`}>{roleLabel}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <Languages />
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({ id: 'SIGNOUT' })}
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
